import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

const SignUPgtm: React.FC<Props> = () => {
    React.useEffect(() => {
        // Datalayer Logic
        const dataLayer = (window as any).dataLayer || [];
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "sign_up",
        });

        console.log("sign_up", dataLayer);
    }, []);

    return <></>;
};

const widgetModule: WidgetModule = {
    component: SignUPgtm,
    definition: {
        displayName: "Sign UP gtm",
        group: "Basic",
    },
};

export default widgetModule;
